// @flow
/**
 * Contains Request-specific util methods
 */

import type { User } from '../services/SPBackend';

const ROLE_NAMES = {
  OWNER: 'Owner',
  STAFF: 'Staff'
};

const ROLE_POWER = {
  Owner: 1,
  Staff: 0
};

const getRolePower = (user: User) => {
  if (typeof user === 'undefined' || user === null) {
    return 0;
  }
  if (user.IsOwner) {
    return 1;
  }
  return 0;
};

const getUserRole = (user: User) => {
  if (typeof user === 'undefined' || user === null) {
    return ROLE_NAMES.STAFF;
  }
  if (user.IsOwner) {
    return ROLE_NAMES.OWNER;
  }
  return ROLE_NAMES.STAFF;
};

export {
  getUserRole,
  getRolePower,
  ROLE_POWER,
  ROLE_NAMES
};
